// src/app/core/services/grupos.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { HttpClientBase } from './http-client-base.service';

export interface Grupo {
  id: number;
  nombre: string;
  orden: number;
  padre?: Grupo | null;
  hijos?: Grupo[];
  tipoGrupo?: string;
  publica: boolean;
}

export interface CreateGrupoDto {
  nombre: string;
  padreId?: number;
  orden?: number;
}

export interface UpdateGrupoDto {
  nombre?: string;
  orden?: number;
  padreId?: number | null;
}

@Injectable({ providedIn: 'root' })
export class GruposService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'grupos');
  }

  /** GET /grupos */
  getAll(trackLoading = true, tipoGrupo: string = ''): Observable<Grupo[]> {
    // console.log('tipoGrupo-service: ', tipoGrupo)
    let url = tipoGrupo != '' ? '?tipoGrupo=' + tipoGrupo : '';
    return this.get<Grupo[]>({
      endpoint: url,
      trackLoading,
    }).pipe(map(resp => resp.body ?? []));
  }

  /** GET /grupos?roots=true */
  getRoots(trackLoading = true): Observable<Grupo[]> {
    return this.get<Grupo[]>({
      endpoint: '?roots=true',
      trackLoading,
    }).pipe(map(resp => resp.body ?? []));
  }

  /** GET /grupos/:id */
  getById(id: number, trackLoading = true): Observable<Grupo> {
    return this.show<Grupo>(id, undefined, undefined, trackLoading);
  }

  /** POST /grupos */
  create(dto: CreateGrupoDto, trackLoading = true): Observable<Grupo> {
    return this.post<Grupo>(dto, '', undefined, trackLoading);
  }

  /** POST /grupos/:padreId/hijos */
  createChild(padreId: number, nombre: string, orden = 0, trackLoading = true): Observable<Grupo> {
    return this.post<Grupo>({ nombre, orden }, `/${padreId}/hijos`, undefined, trackLoading);
  }

  /** PATCH /grupos/:id */
  update(id: number, dto: UpdateGrupoDto, trackLoading = true): Observable<Grupo> {
    // usamos HttpClient directamente, sin redefinir buildUrl
    const url = `${this.baseUrlApi.replace(/\/+$/, '')}/${id}`;
    return this.http.patch<Grupo>(url, dto, {
      context: (this as any)['buildContext']?.(trackLoading),
    });
  }

  /** DELETE /grupos/:id */
  remove(id: number, trackLoading = true): Observable<any> {
    return this.delete<any>(`/${id}`, undefined, undefined, trackLoading);
  }
}
